import type { ChatSessionType } from '@demind-inc/core';
import { SESSION_EMOJI, SuggestedEventType } from '../../../data-access';

// Regex to match emoji characters
const emojiRegex =
  /[\u{1F600}-\u{1F64F}]|[\u{1F300}-\u{1F5FF}]|[\u{1F680}-\u{1F6FF}]|[\u{1F1E0}-\u{1F1FF}]|[\u{2600}-\u{26FF}]|[\u{2700}-\u{27BF}]/u;

export const getTitleBgColor = (sessionType: SuggestedEventType) => {
  switch (sessionType) {
    case 'sleep':
      return '#FF69B4';
    case 'meal':
      return '#680DDB';
    case 'task':
      return '#989DFD';
    case 'routine':
      return '#c9b8ff';
    default:
      return '#c9b8ff';
  }
};

export const getSessionEmoji = (title: string, sessionType: SuggestedEventType) => {
  // Check if title starts with an emoji
  const emojiMatch = title.match(emojiRegex);

  if (emojiMatch) {
    // Return the emoji found in the title
    return emojiMatch[0];
  }

  // If no emoji in title, use default based on session type
  return SESSION_EMOJI[sessionType];
};

export const getTitleWithoutEmoji = (title: string): string => {
  // Remove emoji from the beginning of the title
  return title.replace(emojiRegex, '').trim();
};

export const extractEmojiAndTitle = (title: string, sessionType: SuggestedEventType) => {
  const emoji = getSessionEmoji(title, sessionType);
  const cleanTitle = getTitleWithoutEmoji(title);

  return {
    emoji,
    title: cleanTitle,
  };
};
